import { render, staticRenderFns } from "./userexam.vue?vue&type=template&id=2e05c1a8&scoped=true&"
import script from "./userexam.vue?vue&type=script&lang=js&"
export * from "./userexam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e05c1a8",
  null
  
)

export default component.exports